import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import myLogo from './PPSRServices_Logo.jpg';
export default function Header({ minimal = false }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={`header${minimal ? ' header-minimal' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <i className="fas fa-shield-alt"></i>
              {/*<img src={myLogo} className="logo-home" alt="checkmycarhistory.com.au" className="logo-image" />*/}
              <span>checkmycarhistory<strong>.com.au</strong></span>
            </Link>
          </div>

          {minimal ? (
            <div className="secure-badge">
              <i className="fas fa-lock"></i>
              <span>Secure Checkout</span>
            </div>
          ) : (
            <>
              <nav className={`nav${menuOpen ? ' nav-open' : ''}`} id="mainNav">
                <ul className="nav-list">
                  <li>
                    <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/report-types" className={({ isActive }) => isActive ? 'active' : ''}>
                      Report Types
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/help" className={({ isActive }) => isActive ? 'active' : ''}>
                      Help &amp; FAQ
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </nav>
              <button
                className="mobile-menu-toggle"
                onClick={() => setMenuOpen((o) => !o)}
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
              >
                <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
